const addToCartButtons = document.querySelectorAll('.js-add-to-cart');

if (addToCartButtons.length) {
  [].forEach.call(addToCartButtons, addToCartButton => {
    addToCartButton.addEventListener('click', () => {
      addToCartButton.classList.add('button__loader');
    });
  });
}

$('[data-reveal]').on('closed.zf.reveal', function () {
  let modal = $(this);
  if (addToCartButtons.length) {
    [].forEach.call(addToCartButtons, addToCartButton => {
      addToCartButton.classList.remove('button__loader');
    });
  }
});